module.exports = __webpack_public_path__ + "static/img/Lucas.91d777d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/photoPeople/Lucas.png
// module id = CNjS
// module chunks = 1